import { a as _objectWithoutProperties, _ as _objectSpread2 } from './_rollupPluginBabelHelpers-a38db067.js';
import './utils/html-props.js';
import './utils/svg-props.js';
import './utils/memoize.js';
import { isSvgPropValid } from './utils/is-svg-prop-valid.js';
import { isHtmlPropValid } from './utils/is-html-prop-valid.js';
import { createElement as createElement$1 } from 'react';

const _excluded = ["children"];
function getPropValidator(type) {
  return type === 'svg' ? isSvgPropValid : isHtmlPropValid;
}

/**
 * Creates a React component with the specified HTML element.
 *
 * @deprecated This function is deprecated. Use `createStyledElement` function instead.
 * @template HTMLProps - The type of HTML element props.
 * @template HTMLType - The HTML element type.
 * @param type - The type of the HTML element to create.
 * @returns A React component with the specified HTML element.
 */
function createElement(type) {
  return function Element(_ref) {
    let {
        children
      } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);
    const allProps = _objectSpread2(_objectSpread2({}, props), {}, {
      'data-testid': props.testId,
      ref: props.elRef
    });
    /**
     * Removes data-testid attributes **only** for production build,
     * excluding the 'staging' environment.
     */
    if (process.env.NODE_ENV === 'production' && process.env.REACT_APP_BUILD_ENV !== 'staging') {
      delete allProps['data-testid'];
    }

    /**
     * Extracts props valid for the specified HTML element type.
     */
    const propsForElement = {};

    /**
     * Validates if a prop is valid for the specified HTML element type.
     */
    const propValidator = getPropValidator(type);

    /**
     * Populates propsForElement with valid props from allProps.
     */
    let key = '';
    for (key in allProps) {
      if (propValidator(key)) {
        propsForElement[key] = allProps[key];
      }
    }
    return /*#__PURE__*/createElement$1(type, propsForElement, children);
  };
}

export { createElement };
